import script from "./FormularioInscripcionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioInscripcionCard.vue?vue&type=script&setup=true&lang=js"

import "./FormularioInscripcionCard.vue?vue&type=style&index=0&id=86d154e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d154e8"]])

export default __exports__